import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text, View } from "react-native";
import { connect } from "react-redux";

import PrescriptionHistoryDetail from "./PrescriptionHistoryDetail";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class PrescriptionHistoryItem extends React.Component {
  static propTypes = {
    createdAt: PropTypes.instanceOf(Date).isRequired,
    prescription: PropTypes.shape({
      id: PropTypes.string.isRequired,
      prescriptionNo: PropTypes.string,
      lifepackSubscriptionId: PropTypes.string,
      patientName: PropTypes.string.isRequired,
      patientClass: PropTypes.string,
      status: PropTypes.string,
      prescriptionDate: PropTypes.string,
      lifepack: PropTypes.object
    }).isRequired,
    navigation: PropTypes.object.isRequired,
  };

  render() {
    const { createdAt, prescription, themeColors, navigation } = this.props;
    return (
      <>
        <View
          style={{
            marginBottom: 10,
          }}
        >
          <Text
            style={[
              styles.section,
              { color: themeColors.primary, ...fonts.bold },
            ]}
          >
            {I18n.t("prixa.prescriptionOn", {
              date: I18n.l("date.prixa.default", createdAt),
              time: I18n.l("time.prixa.default", createdAt),
            })}
          </Text>
        </View>
        <PrescriptionHistoryDetail
          navigation={navigation}
          data={prescription}
        />
      </>
    );
  }
}

const styles = StyleSheet.create({
  createdAt: {
    fontSize: 14,
    marginBottom: 8,

    ...fonts.regular,
  },
  summary: {
    color: staticColors.grey,
    fontSize: 10,
    marginTop: 5,
    textAlign: "justify",

    ...fonts.regular,
  },
  section: {
    fontSize: 16,

    ...fonts.regular,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryItem);
